/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import PropTypes from "prop-types";
import Input from "./input";
import Label from "./label";

function Field({
  children = null,
  className: _className = null,
  label: text = null,
  name,
  namespace = null,
  type = "text",
  ..._props
}) {
  const className = [_className, `form-${type}`].filter(Boolean).join(" ");
  const id = namespace ? [namespace, name].join("-") : name;
  const inputProps = {id, ..._props, name, type};
  const labelProps = {className, htmlFor: id};
  const label = text || children;
  const after = label && type === "checkbox";
  const before = label && !after;

  return (
    <Label {...labelProps}>
      {before && label}
      <Input {...inputProps} />
      {after && label}
    </Label>
  );
}

Field.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  namespace: PropTypes.string,
  type: PropTypes.string
};

export default Field;
